import { render, staticRenderFns } from "./Filler.vue?vue&type=template&id=3bd28456&scoped=true&"
import script from "./Filler.vue?vue&type=script&lang=ts&"
export * from "./Filler.vue?vue&type=script&lang=ts&"
import style0 from "./Filler.vue?vue&type=style&index=0&id=3bd28456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd28456",
  null
  
)

export default component.exports